import 'client-only';

import { useFlashMessages } from '@/atoms/flashMessages/useFlashMessages';
import { type Brand } from '@/consts/brands';
import { SESSION_EXPIRED_STATUSES } from '@/consts/sessionExpiredStatuses';
import { urls } from '@/utils/urls';

export { SESSION_EXPIRED_STATUSES };

export const useSessionExpired = (brand: Brand) => {
  const flashMessages = useFlashMessages();

  const handleIfSessionExpired = (status: number | undefined): boolean => {
    if (!status || !SESSION_EXPIRED_STATUSES.includes(status)) {
      return false;
    }

    flashMessages.error({
      title: 'Session expired',
      message:
        'Your session has expired. Please log in again to continue. You will be redirected in 3 seconds.',
    });

    setTimeout(() => {
      const loginBase = urls[brand].legacy.auth.login;
      const loginUrl = SESSION_EXPIRED_STATUSES.includes(status)
        ? `${loginBase}?signupRedirect=${encodeURIComponent(window.location.href)}`
        : loginBase;
      window.location.assign(loginUrl);
    }, 3000);

    return true;
  };

  return { handleIfSessionExpired };
};
